import { FatDealCatalogPageOpenOpportunitiesQuery } from '@/__generated__/graphql';
import { Loader } from '@/components/loaders/loader';
import TableHeader from '@/components/table/tableHeader';
import { ISort } from '@/components/table/types';
import { useResponsive } from '@/hooks/use-responsive';
import styled from 'styled-components';
import { TableBodyWrapper, TableWrapper } from '../../table/styles';
import { opportunitiesTableColumns } from '../constants';
import { TypeWindow } from '../types';
import MobileTable from './mobileTable';
import TableBody from './tableBody';

interface OpenOpportunitiesTableProps {
  openPage: (id: string, type: TypeWindow) => void;
  loading: boolean;
  openOpportunitiesData: FatDealCatalogPageOpenOpportunitiesQuery['OpenOpportunities']['data'];
  refetch: () => void;
  sort: ISort;
  setSort: (value: ISort) => void;
}

const OpportunitiesTable = ({ openPage, loading, openOpportunitiesData, refetch, sort, setSort }: OpenOpportunitiesTableProps) => {
  const { isMobile } = useResponsive();

  return (
    <TableWrapper padding="0">
      {isMobile ? (
        <>{loading ? <CustomLoader /> : <MobileTable openOpportunitiesData={openOpportunitiesData} openPage={openPage} />}</>
      ) : (
        <>
          <TableHeader refetch={refetch} columns={opportunitiesTableColumns} savedSort={sort} savedSetSort={setSort} />
          <TableBodyWrapper>
            {loading ? <CustomLoader /> : <TableBody openOpportunitiesData={openOpportunitiesData} openPage={openPage} />}
          </TableBodyWrapper>
        </>
      )}
    </TableWrapper>
  );
};

export default OpportunitiesTable;

const CustomLoader = styled(Loader)`
  height: 50vh;
`;
